import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";

import BgImage from "../../../assets/images/Swipex_BG_image.jpg";
import DatePicker from "react-datepicker";
import Icon from '@mui/material/Icon';
import { green, red } from '@mui/material/colors';
import ImageIcon from "../../../assets/images/Swipex_Upload_icon.png";
import ImageIconDull from "../../../assets/images/Swipex_Upload_icon_dull.png";

import SwitchImage1 from "../../../assets/images/switch_white.png"
import SwitchImage2 from "../../../assets/images/switch.png";
import SwipexImage from "../../../assets/images/SWIPEX_2.0_Transparent.png"
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import { GET_SWIPEX_DETAILS, APP_BASE_URL } from "../../AppConstant";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

function See({ handleCloseSeeModal, setParentLoading }) {

const tableRef1 = useRef(null);

const waitForImagesToLoad = async (container) => {

    const images = container.querySelectorAll("img");

    await Promise.all(

        Array.from(images).map((img) => {

            if (img.complete) {

                return Promise.resolve();

            }

            return new Promise((resolve) => {

                img.onload = resolve;

                img.onerror = resolve;

            });

        })

    );
};

const downloadTableAsImage = async () => {

    try {

        setParentLoading(true);

        const element = tableRef1.current;

        if (!element) {
            throw new Error("Table element not found");
        }

        const addRefToImage = async (ref) => {

            console.log("ref:", ref);

            console.log("current:", ref?.current);

            await waitForImagesToLoad(ref.current);

            const canvas = await html2canvas(
                ref.current,
                {
                    scale: 2,

                    useCORS: true,

                    backgroundColor: "#ffffff",

                    windowWidth: 1440,
                }
            );

            /*
             * Convert canvas to PNG image
             */
            const imgData =
                canvas.toDataURL(
                    "image/png"
                );

            /*
             * Create download link
             */
            const link =
                document.createElement("a");

            link.href = imgData;

            const swipexid =
                localStorage.getItem(
                    "swipexid"
                ) ||
                "Submitted_Table";

            link.download =
                `${swipexid}.png`;

            /*
             * Trigger download
             */
            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);
        };

        await addRefToImage(tableRef1);

    } catch (error) {

        console.error(
            "Image generation failed:",
            error
        );

    } finally {

        setTimeout(() => {

            setParentLoading(false);

        }, 500);
    }
};

    const [Accepted, setIsAccepted] = useState(false);

    const [swipexID, setSwipexID] = useState("");
    const [empName, setEmpName] = useState("");
    const [empID, setEmpID] = useState("");
    const [location, setLocation] = useState("");
    const [department, setDepartment] = useState("");
    const [validator, setValidator] = useState("");
    const [approver, setApprover] = useState("");

    const [startDate, setStartDate] = useState("");
    const [implementDate, setImplementDate] = useState("");

    // IMPROVEMENT CATEGORY 
    const [improvementCategory, setImprovementCategory] = useState({
        productivity: false,
        quality: false,
        cost: false,
        delivery: false,
        safety: false,
        morale: false
    })

    // BENEFITS 
    const [benefits, setBenefits] = useState({
        productivity: "",
        quality: "",
        cost: "",
        delivery: "",
        safety: "",
        morale: ""
    })

    // PROBLEM DEFINITION & ACTIONS :
    const [titleProblemDefinition, setTitleProblemDefinition] = useState("");
    const [whatProblemDefinition, setWhatProblemDefinition] = useState("");
    const [whyProblemDefinition, setWhyProblemDefinition] = useState("");
    const [whenProblemDefinition, setWhenProblemDefinition] = useState("");
    const [howManyProblemDefinition, setHowManyProblemDefinition] = useState("");
    const [whatactionscount, setWhatActionsCount] = useState(1);

    const [whatActions, setWhatActions] = useState({
        what1: "",
        what2: "",
        what3: "",
    })
    const [whenActions, setWhenActions] = useState({
        when1: "",
        when2: "",
        when3: ""
    });
    const [whoActions, setWhoActions] = useState({
        who1: "",
        who2: "",
        who3: ""
    });
    const [howActions, setHowActions] = useState({
        how1: "",
        how2: "",
        how3: ""
    });

    // IMAGES
    const [problemImagesPreview, setProblemImagesPreview] = useState([]);
    const [beforeImagePreview, setBeforeImagePreview] = useState(ImageIcon);
    const [afterImagePreview, setAfterImagePreview] = useState(ImageIcon);
    const [imagesDescription, setImagesDescription] = useState({
        ProblemImageDescription: "",
        BeforeImageDescription: "",
        AfterImageDescription: ""
    })

    // OBSERVATION & ANALYSIS
    const [observationAnalysis, setObservationAnalysis] = useState("Man");

    // WHAT, WHY ROOT CAUSE
    const [rootCauseProblemStatement, setRootCauseProblemStatement] = useState("");

    const [whyrootcausecount, setWhyRootCauseCount] = useState(1);

    const [whyRootCause, setWhyRootCause] = useState({
        why1: "",
        why2: "",
        why3: "",
        why4: "",
        why5: ""
    })

    // STANDARDISATION
    const [standardisation, setStandardisation] = useState({
        controlplan: false,
        wis: false,
        pfmea: false,
        pmchecklist: false,
        checksheet: false,
        procedure: false,
        designchange: false,
        others: false
    })

    // DOCUMENT NUMBERS 
    const [documentNumbersRevisionDetails, setDocumentNumbersRevisionDetails] = useState({
        controlplan: "",
        wis: "",
        pfmea: "",
        pmchecklist: "",
        checksheet: "",
        procedure: "",
        designchange: "",
        others: ""
    });

    // SUPPORTING TEAM MEMBERS
    const [supportingTeamMembers, setSupportingTeamMembers] = useState("");

    // GET SWIPEX DETAILS 
    const getswipexdetails = async () => {
        try {
            const swipexid = localStorage.getItem("swipexid");
            setSwipexID(swipexid);

            const res = await axios.get(GET_SWIPEX_DETAILS, {
                params: { swipexid }
            });

            setEmpID(res.data.empid);
            setEmpName(res.data.empname);
            setLocation(res.data.location);
            setDepartment(res.data.department);
            setValidator(res.data.validatorname);
            setApprover(res.data.approvername);

            setStartDate(res.data.startdate);
            setImplementDate(res.data.implementdate);

            setImprovementCategory({
                productivity: res.data.productivity,
                quality: res.data.quality,
                cost: res.data.cost,
                delivery: res.data.delivery,
                safety: res.data.safety,
                morale: res.data.morale
            });

            setTitleProblemDefinition(res.data.titleproblemdefinition);
            setWhatProblemDefinition(res.data.whatproblemdefinition);
            setWhyProblemDefinition(res.data.whyproblemdefinition);
            setWhenProblemDefinition(res.data.whenproblemdefinition);
            setHowManyProblemDefinition(res.data.howmanyproblemdefinition);

            setWhatActions({
                what1: res.data.whatactions1,
                what2: res.data.whatactions2,
                what3: res.data.whatactions3,
            })
            setWhenActions({
                when1: res.data.whenactions1,
                when2: res.data.whenactions2,
                when3: res.data.whenactions3,
            })
            setWhoActions({
                who1: res.data.whoactions1,
                who2: res.data.whoactions2,
                who3: res.data.whoactions3,
            })
            setHowActions({
                how1: res.data.howactions1,
                how2: res.data.howactions2,
                how3: res.data.howactions3,
            })

            setWhatActionsCount(res.data.whatactions3 ? 3 : res.data.whatactions2 ? 2 : 1);

            const imageUrls = [
                `${APP_BASE_URL}/swipex/getimage/${swipexid}/problemfilepath1/`,
                `${APP_BASE_URL}/swipex/getimage/${swipexid}/problemfilepath2/`,
                `${APP_BASE_URL}/swipex/getimage/${swipexid}/problemfilepath3/`,
            ];

            const validImages = await Promise.all(
                imageUrls.map(
                    url =>
                        new Promise(resolve => {
                            const img = new Image();

                            img.onload = () => resolve(url);
                            img.onerror = () => resolve(null);

                            img.src = url;
                        })
                )
            );

            setProblemImagesPreview(validImages.filter(Boolean));

            setBeforeImagePreview(`${APP_BASE_URL}/swipex/getimage/${swipexid}/beforefilepath/`);
            setAfterImagePreview(`${APP_BASE_URL}/swipex/getimage/${swipexid}/afterfilepath/`);

            setImagesDescription({
                ProblemImageDescription: res.data.problemimagedescription,
                BeforeImageDescription: res.data.beforeimagedescription,
                AfterImageDescription: res.data.afterimagedescription
            })

            setObservationAnalysis(res.data.obervationanalysis);
            console.log(`|${observationAnalysis}|`);
            console.log(`|${res.data.obervationanalysis}|`);
            console.log(observationAnalysis === "Method");

            setStandardisation({
                controlplan: res.data.s_controlplan,
                wis: res.data.s_wis,
                pfmea: res.data.s_pfmea,
                pmchecklist: res.data.s_pmchecklist,
                checksheet: res.data.s_checksheet,
                procedure: res.data.s_procedure,
                designchange: res.data.s_designchange,
                others: res.data.s_others
            })

            setBenefits({
                productivity: res.data.productivitytext,
                quality: res.data.qualitytext,
                cost: res.data.costtext,
                delivery: res.data.deliverytext,
                safety: res.data.safetytext,
                morale: res.data.moraletext
            })

            setRootCauseProblemStatement(res.data.problemstatement)

            setWhyRootCause({
                why1: res.data.why1,
                why2: res.data.why2,
                why3: res.data.why3,
                why4: res.data.why4,
                why5: res.data.why5
            })

            setWhyRootCauseCount(res.data.why5 ? 5 : res.data.why4 ? 4 : res.data.why3 ? 3 : res.data.why2 ? 2 : 1);

            setDocumentNumbersRevisionDetails({
                controlplan: res.data.s_controlplantext,
                wis: res.data.s_wistext,
                pfmea: res.data.s_pfmeatext,
                pmchecklist: res.data.s_pmchecklisttext,
                checksheet: res.data.s_checksheettext,
                procedure: res.data.s_proceduretext,
                designchange: res.data.s_designchangetext,
                others: res.data.s_otherstext
            })

            setSupportingTeamMembers(res.data.supportingteammembers);

            if (res.data.status == "A"){
                setIsAccepted(true);
            }

        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getswipexdetails();
    }, [])

    const handleImageDownload = async (imageSrc) => {
        try {
            const response = await fetch(imageSrc);

            var imagename = "";

            if (imageSrc.split("/").filter(Boolean).pop() == "problemfilepath1") {
                imagename = "Probelm-Image-1";
            } else if (imageSrc.split("/").filter(Boolean).pop() == "problemfilepath2") {
                imagename = "Probelm-Image-2";
            } else if (imageSrc.split("/").filter(Boolean).pop() == "problemfilepath3") {
                imagename = "Probelm-Image-3";
            } else if (imageSrc.split("/").filter(Boolean).pop() == "beforefilepath") {
                imagename = "Before-Image";
            } else if (imageSrc.split("/").filter(Boolean).pop() == "afterfilepath") {
                imagename = "After-Image";
            }

            if (!response.ok) {
                throw new Error("Failed to download image");
            }

            const blob = await response.blob();

            // Create temporary URL for the image
            const blobUrl = window.URL.createObjectURL(blob);

            // Create temporary download link
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = `${swipexID}-${imagename}.jpg`;

            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);

        } catch (error) {
            console.error("Image download failed:", error);
        }
    };

    const [imagePreview, setImagePreview] = useState(null);

    const [showImageModal, setShowImageModal] = useState(false);
    const handleOpenImageModal = async (preview) => {
        setParentLoading(true);
        setShowImageModal(true);
        setImagePreview(preview);

        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };
    const handleCloseImageModal = () => {
        setParentLoading(true);
        setShowImageModal(false);
        setImagePreview(null);
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

    const [dx, setDx] = useState(0);
    const [dy, setDy] = useState(0);
    const [zoom, setZoom] = useState(1);

    const zoomIn = () => {
        setZoom((prev) => prev + 0.2);
    };
    const zoomOut = () => {
        setZoom((prev) => Math.max(1, prev - 0.2));
    };
    const reset = () => {
        setZoom(1);
        setDx(0);
        setDy(0);
    };
    const onPan = (x, y) => {
        setDx(x);
        setDy(y);
    };

    return (<>

        <Modal.Body className="p-0" style={{
            backgroundImage: `url(${BgImage})`,
            minHeight: "100vh",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
        }}>

            <div style={{ fontFamily: "Aptos, 'Aptos Body', sans-serif", }}>

                {/* PROJECT DETAILS */}

                <div className="container">
                    <div className="row">
                        <div className="col-2"></div>
                        <div className="col-8">
                            <b style={{ fontSize: "15px", color: "papayawhip", display: "flex", alignItems: "center", justifyContent: "center" }}>Project Details</b>
                            <div style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px", }}>

                                <div className="row pt-3">
                                    <div className="col-5">
                                        <h6 className="fw-bold" style={{ fontSize: "15px", display: "flex", alignItems: "center", justifyContent: "center" }}>SWIPEX ID</h6>
                                    </div>
                                    <div className="col-5">
                                        <p className="fw-bold" style={{ color: "green", fontSize: "15px", display: "flex", alignItems: "center", justifyContent: "center" }}>{swipexID}</p>
                                    </div>
                                    <div className="col-2">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-5">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center" }}>Leader Name / Emp Name</h6>
                                    </div>
                                    <div className="col-5">
                                        <p className="fw-bold text-primary" style={{ fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center" }}>{empName}</p>
                                    </div>
                                    <div className="col-2">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-5">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center" }}> Emp ID / No.</h6>
                                    </div>
                                    <div className="col-5">
                                        <p className="fw-bold text-primary" style={{ fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center" }}>{empID}</p>
                                    </div>
                                    <div className="col-2">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-5">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center" }}>Department</h6>
                                    </div>
                                    <div className="col-5">
                                        <p className="fw-bold text-primary" style={{ fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center" }}>{department}</p>
                                    </div>
                                    <div className="col-2">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-5">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center" }}>Location</h6>
                                    </div>
                                    <div className="col-5">
                                        <p className="fw-bold text-primary" style={{ fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center" }}>{location}</p>
                                    </div>
                                    <div className="col-2">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-5">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center" }}>Start Date</h6>
                                    </div>
                                    <div className="col-5">
                                        <p style={{ fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "whitesmoke" }}>{startDate}</p>
                                    </div>
                                    <div className="col-2">
                                    </div>
                                </div>

                                <div className="row pb-1">
                                    <div className="col-5">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center" }}>Implement Date</h6>
                                    </div>
                                    <div className="col-5">
                                        <p style={{ fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "whitesmoke" }}>{implementDate}</p>
                                    </div>
                                    <div className="col-2">
                                    </div>
                                </div>


                            </div>
                        </div>
                        <div className="col-2"></div>
                    </div>
                </div>

                {/* BORDER */}

                <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                    {"+ - ".repeat(1000)}
                </div>

                {/* IMPROVEMNT CATEGORY */}

                <div className="container" >
                    <div className="row">
                        <b style={{ fontSize: "15px", color: "papayawhip", display: "flex", alignItems: "center", justifyContent: "center" }}>Improvement Category</b>
                        <div className="mb-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px", fontStyle: "italic" }}>
                            <div className="row">
                                <div className="col-12">
                                    <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }} className="ps-5" >
                                        <input type="checkbox" id="productivity" name="productivity" className="custom-checkbox" style={{ transform: "scale(1.5)", cursor: "pointer" }} checked={improvementCategory.productivity} readOnly />
                                        <label htmlFor="productivity" style={{ cursor: "pointer" }}>Productivity</label>

                                        <input type="checkbox" id="quality" name="quality" className="custom-checkbox" style={{ transform: "scale(1.5)", cursor: "pointer" }} checked={improvementCategory.quality} readOnly />
                                        <label htmlFor="quality" style={{ cursor: "pointer" }}>Quality</label>

                                        <input type="checkbox" id="cost" name="cost" className="custom-checkbox" style={{ transform: "scale(1.5)", cursor: "pointer" }} checked={improvementCategory.cost} readOnly />
                                        <label htmlFor="cost" style={{ cursor: "pointer" }}>Cost</label>

                                        <input type="checkbox" id="delivery" name="delivery" className="custom-checkbox" style={{ transform: "scale(1.5)", cursor: "pointer" }} checked={improvementCategory.delivery} readOnly />
                                        <label htmlFor="delivery" style={{ cursor: "pointer" }}>Delivery</label>

                                        <input type="checkbox" id="safety" name="safety" className="custom-checkbox" style={{ transform: "scale(1.5)", cursor: "pointer" }} checked={improvementCategory.safety} readOnly />
                                        <label htmlFor="safety" style={{ cursor: "pointer" }}>Safety</label>

                                        <input type="checkbox" id="morale" name="morale" className="custom-checkbox" style={{ transform: "scale(1.5)", cursor: "pointer" }} checked={improvementCategory.morale} readOnly />
                                        <label htmlFor="morale" style={{ cursor: "pointer" }}>Morale</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                {/* BORDER */}

                <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                    {"+ - ".repeat(1000)}
                </div>

                {/* PROBLEM DEFINITION  */}

                <div className="container">
                    <div className="row">
                        <b style={{ fontSize: "15px", color: "papayawhip", display: "flex", alignItems: "center", justifyContent: "center" }}>Problem Definition (1T 3W 1H)</b>
                        <div className="pt-4 mb-2 pb-4" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px" }}>
                            {/* Title */}
                            <div className="row" style={{ alignItems: "center" }}>
                                <div className="col-3">
                                </div>
                                <div className="col-1 pt-2">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "end", }}>Title :</h6>
                                </div>
                                <div className="col-5 p-0">
                                    <p className="p-0 px-1 m-0 text-start  border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{titleProblemDefinition}</p>
                                </div>
                                <div className="col-3">
                                </div>

                            </div>

                            <div className="row">
                                <div className="col-6 mt-4">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>What :</h6>
                                    <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{whatProblemDefinition}</p>
                                </div>
                                <div className="col-6 mt-4">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>Why :</h6>
                                    <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{whyProblemDefinition}</p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6 mt-4">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>When :</h6>
                                    <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{whenProblemDefinition}</p>
                                </div>
                                <div className="col-6 mt-4">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>How Many :</h6>
                                    <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{howManyProblemDefinition}</p>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                {/* BORDER */}

                <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                    {"+ - ".repeat(1000)}
                </div>

                {/* PROBLEM IMAGES */}

                <div className="container">
                    <div className="row">
                        {/* Problem Images */}
                        <div className="col-12">
                            <b style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", textAlign: "center" }}>Problem / Present Status <br></br>(Include pictures / diagrams, etc..,)</b>
                            <div className="pt-1 mb-2 pb-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px" }}>
                                <div className="d-flex justify-content-center gap-3 mt-3">
                                    {[0, 1, 2].map((index) => {
                                        const file = problemImagesPreview[index];
                                        const preview = file;

                                        const canUpload =
                                            index === 0 || !!problemImagesPreview[index - 1];

                                        return (
                                            <div className={index == 0 || index == 1 ? "border-primary border-2 border-end" : null}
                                                key={index}
                                                style={{
                                                    width: "400px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                }}
                                            >
                                                {preview ? (
                                                    <>
                                                        {/* Image */}
                                                        <img
                                                            src={preview}
                                                            alt={`Preview ${index + 1}`}
                                                            style={{
                                                                width: "250px",
                                                                height: "180px",
                                                                objectFit: "fill", // Fill the border completely
                                                                border: "1px solid #ddd",
                                                                borderRadius: "8px",
                                                                cursor: "pointer"
                                                            }}
                                                            onClick={() => handleOpenImageModal(preview)}
                                                        />

                                                    </>
                                                ) : (
                                                    <div
                                                        className="d-flex justify-content-center align-items-center"
                                                        style={{
                                                            width: "180px",
                                                            height: "200px", // 180px image + ~28px toolbar space
                                                        }}
                                                    >
                                                        <img
                                                            src={canUpload ? ImageIconDull : ImageIconDull}
                                                            alt="Upload"
                                                            style={{
                                                                width: "50px",
                                                                height: "50px",
                                                                cursor: canUpload ? "pointer" : "default",
                                                                objectFit: "contain",
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className="mx-3">
                                    <h6 className="fw-bold" style={{ fontSize: "15px", textAlign: "start", }}> Description :</h6>
                                    <p className="p-0 px-1 m-0 text-start  border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{imagesDescription.ProblemImageDescription}</p>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                {/* BORDER */}

                <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                    {"+ - ".repeat(1000)}
                </div>

                {/* OBSERVATION & ANALYSIS */}

                <div className="container" >
                    <div className="row">
                        <div className="col-3"></div>

                        <div className="col-6">

                            <b style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", textAlign: "center" }}>Observation & Analysis</b>
                            <div style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px", fontStyle: "italic" }}>

                                <div className="ps-5 d-flex align-items-center gap-4" >
                                    <div className="d-flex align-items-center" >
                                        <input readOnly checked={observationAnalysis === "Man"} type="radio" id="oa1" name="oa" value="Man" style={{ width: "16px", height: "16px", accentColor: "blue", verticalAlign: "middle" }} />
                                        <label htmlFor="oa1" className="ms-2 mb-0" style={{ cursor: "pointer" }}> Man </label>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <input readOnly checked={observationAnalysis === "Machine"} type="radio" id="oa2" name="oa" value="Machine" style={{ width: "16px", height: "16px", accentColor: "blue", verticalAlign: "middle" }} />
                                        <label htmlFor="oa2" className="ms-2 mb-0" style={{ cursor: "pointer" }}> Machine </label>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <input readOnly checked={observationAnalysis === "Method"} type="radio" id="oa3" name="oa" value="Method" style={{ width: "16px", height: "16px", accentColor: "blue", verticalAlign: "middle" }} />
                                        <label htmlFor="oa3" className="ms-2 mb-0" style={{ cursor: "pointer" }}> Method </label>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <input readOnly checked={observationAnalysis === "Material"} type="radio" id="oa4" name="oa" value="Material" style={{ width: "16px", height: "16px", accentColor: "blue", verticalAlign: "middle" }} />
                                        <label htmlFor="oa4" className="ms-2 mb-0" style={{ cursor: "pointer" }}> Material </label>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="col-3"></div>
                    </div>
                </div>

                {/* BORDER */}

                <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                    {"+ - ".repeat(1000)}
                </div>

                {/* ROOT CAUSE */}

                <div className="container">
                    <div className="row">
                        <div className="col-6">
                            <b style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", textAlign: "center" }}>Root Cause</b>
                            <div className="pt-3 mb-2 pb-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "30px" }}>
                                <div className="row m-2 pb-4" style={{ alignItems: "center" }}>
                                    <div className="col-12">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Problem Statement :</h6>
                                        <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{rootCauseProblemStatement}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* WHY */}
                        <div className="col-6">
                            <div className="pt-3 mb-2 pb-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "30px" }}>

                                {/* 1,2 */}
                                <div className="row px-1">


                                    {/* WHY 1 */}
                                    <div className="col-6">

                                        <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>Why 1 :</h6>
                                        <p className="p-0 px-1 m-0 border border-success rounded" style={{ fontSize: "13px", textAlign: "justify", backgroundColor: "whitesmoke" }}>{whyRootCause.why1}</p>

                                    </div>

                                    {/* WHY 2 */}
                                    <div className="col-6">

                                        {whyrootcausecount > 1 && <>
                                            <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>Why 2 :</h6>
                                            <p className="p-0 px-1 m-0 border border-success rounded" style={{ fontSize: "13px", textAlign: "justify", backgroundColor: "whitesmoke" }}>{whyRootCause.why2}</p>
                                        </>}
                                    </div>

                                </div>

                                {/* 3,4 */}

                                <div className="row mt-2 px-1">
                                    {/* WHY 3 */}
                                    <div className="col-6">
                                        {whyrootcausecount > 2 && <>
                                            <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>Why 3 :</h6>
                                            <p className="p-0 px-1 m-0 border border-success rounded" style={{ fontSize: "13px", textAlign: "justify", backgroundColor: "whitesmoke" }}>{whyRootCause.why3}</p>
                                        </>}
                                    </div>

                                    {/* WHY 4 */}
                                    <div className="col-6">
                                        {whyrootcausecount > 3 && <>
                                            <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>Why 4 :</h6>
                                            <p className="p-0 px-1 m-0 border border-success rounded" style={{ fontSize: "13px", textAlign: "justify", backgroundColor: "whitesmoke" }}>{whyRootCause.why4}</p>
                                        </>}
                                    </div>
                                </div>

                                {/* 5 */}

                                <div className="row mt-2">
                                    <div className="col-3"></div>
                                    {/* WHY 5 */}
                                    <div className="col-6">
                                        {whyrootcausecount > 4 && <>
                                            <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>Why 5 :</h6>
                                            <p className="p-0 px-1 m-0 border border-success rounded" style={{ fontSize: "13px", textAlign: "justify", backgroundColor: "whitesmoke" }}>{whyRootCause.why5}</p>
                                        </>}
                                    </div>
                                    <div className="col-3"></div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                {/* BORDER */}

                <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                    {"+ - ".repeat(1000)}
                </div>

                {/* ACTIONS */}

                <div className="container">
                    <div className="row">

                        <b style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", textAlign: "center" }}>Actions (3W 1H)</b>

                        {/* actions 1 */}
                        <div className="pt-3 mb-2 pb-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px" }}>
                            <b style={{ color: "green", display: "block", textAlign: "start", fontSize: "15px", }}>Action - I</b>
                            <div className="row m-2" style={{ alignItems: "center" }}>
                                <div className="col-6">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>What 1 :</h6>
                                    <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{whatActions.what1}</p>
                                </div>
                                <div className="col-6" style={{ alignContent: "center" }}>
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>When 1 :</h6>
                                    <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{whenActions.when1}</p>
                                </div>
                            </div>

                            <div className="row m-2 pb-1 pt-2">
                                <div className="col-6">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>Who 1 :</h6>
                                    <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{whoActions.who1}</p>
                                </div>
                                <div className="col-6">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>How 1 :</h6>
                                    <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{howActions.how1}</p>
                                </div>
                            </div>

                        </div>

                        {/* actions 2 */}
                        {whatactionscount > 1 && <>
                            <div className="pt-3 mb-2 pb-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px" }}>
                                <b style={{ color: "green", display: "block", textAlign: "start", fontSize: "15px", }}>Action - II</b>
                                <div className="row m-2" style={{ alignItems: "center" }}>
                                    <div className="col-6">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>What 2 :</h6>
                                        <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{whatActions.what2}</p>
                                    </div>
                                    <div className="col-6" style={{ alignContent: "center" }}>
                                        <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>When 2 :</h6>
                                        <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{whenActions.when2}</p>
                                    </div>
                                </div>

                                <div className="row m-2 pb-3 pt-2">
                                    <div className="col-6">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>Who 2 :</h6>
                                        <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{whoActions.who2}</p>
                                    </div>
                                    <div className="col-6">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>How 2 :</h6>
                                        <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{howActions.how2}</p>
                                    </div>
                                </div>
                            </div>
                        </>}

                        {/* actions 3 */}
                        {whatactionscount > 2 && <>
                            <div className="pt-3 mb-2 pb-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px" }}>
                                <b style={{ color: "green", display: "block", textAlign: "start", fontSize: "15px", }}>Action - III</b>
                                <div className="row m-2" style={{ alignItems: "center" }}>
                                    <div className="col-6">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>What 3 :</h6>
                                        <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{whatActions.what3}</p>
                                    </div>
                                    <div className="col-6" style={{ alignContent: "center" }}>
                                        <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>When 3 :</h6>
                                        <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{whenActions.when3}</p>
                                    </div>
                                </div>

                                <div className="row m-2 pb-3 pt-2">
                                    <div className="col-6">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>Who 3 :</h6>
                                        <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{whoActions.who3}</p>
                                    </div>
                                    <div className="col-6">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>How 3 :</h6>
                                        <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{howActions.how3}</p>
                                    </div>
                                </div>

                            </div>
                        </>}
                    </div>

                </div>

                {/* BORDER */}

                <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                    {"+ - ".repeat(1000)}
                </div>

                {/* BEFORE, AFTER IMAGE */}

                <div className="container">
                    <div className="row">
                        <div className="col-2"></div>

                        <div className="col-4">
                            <b style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", textAlign: "center" }}>Before <br></br>(Include pictures/ <br></br>diagrams, etc..,)</b>
                            <div className="pt-3 mb-2 pb-2 px-5" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "200px", borderRadius: "10px" }}>
                                <img src={beforeImagePreview} alt="Before Image" style={{ width: "100%", objectFit: "fill", height: "180px", cursor: "pointer" }} onClick={() => handleOpenImageModal(beforeImagePreview)} />
                            </div>

                            <div>
                                <h6 className="fw-bold" style={{ fontSize: "15px", textAlign: "start", color: "papayawhip" }}> Description :</h6>
                                <p className="p-0 px-1 m-0 text-start  border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{imagesDescription.BeforeImageDescription}</p>
                            </div>
                        </div>
                        <div className="col-4">
                            <b style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", textAlign: "center" }}>After <br></br>(Include pictures/ <br></br>diagrams, etc..,)</b>
                            <div className="pt-3 mb-2 pb-2 px-5" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "200px", borderRadius: "10px" }}>
                                <img src={afterImagePreview} alt="After Image" style={{ width: "100%", objectFit: "fill", height: "180px", cursor: "pointer" }} onClick={() => handleOpenImageModal(afterImagePreview)} />
                            </div>

                            <div>
                                <h6 className="fw-bold" style={{ fontSize: "15px", textAlign: "start", color: "papayawhip" }}> Description :</h6>
                                <p className="p-0 px-1 m-0 text-start  border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{imagesDescription.AfterImageDescription}</p>
                            </div>
                        </div>

                        <div className="col-2"></div>
                    </div>
                </div>

                {/* BORDER */}

                <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                    {"+ - ".repeat(1000)}
                </div>

                {/* STANDARDISATION, DOCUMENT NUMBERS & REVISION DETAILS */}

                <div className="container">
                    <div className="row">

                        {/* Standardisation */}
                        <b style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", alignItems: "center" }}>Standardisation</b>
                        <div className="mb-3" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px", fontStyle: "italic" }}>
                            <div className="row">
                                <div className="col-12">
                                    <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }} className="ps-3" >
                                        <input type="checkbox" id="controlplan" name="controlplan" value="Control Plan" style={{ transform: "scale(1.5)", cursor: "pointer" }} readOnly checked={standardisation.controlplan} />
                                        <label htmlFor="controlplan" className="custom-checkbox" style={{ cursor: "pointer" }}> Control Plan </label>

                                        <input type="checkbox" id="wis" name="wis" value="WIS" style={{ transform: "scale(1.5)", cursor: "pointer" }} readOnly checked={standardisation.wis} />
                                        <label htmlFor="wis" className="custom-checkbox" style={{ cursor: "pointer" }}> WIS </label>

                                        <input type="checkbox" id="pfmea" name="pfmea" value="PFMEA" style={{ transform: "scale(1.5)", cursor: "pointer" }} readOnly checked={standardisation.pfmea} />
                                        <label htmlFor="pfmea" className="custom-checkbox" style={{ cursor: "pointer" }}> PFMEA </label>

                                        <input type="checkbox" id="pmchecklist" name="pmchecklist" value="PM Check list" style={{ transform: "scale(1.5)", cursor: "pointer" }} readOnly checked={standardisation.pmchecklist} />
                                        <label htmlFor="pmchecklist" className="custom-checkbox" style={{ cursor: "pointer" }}> PM Check list </label>

                                        <input type="checkbox" id="checksheet" name="checksheet" value="Check sheet" style={{ transform: "scale(1.5)", cursor: "pointer" }} readOnly checked={standardisation.checksheet} />
                                        <label htmlFor="checksheet" className="custom-checkbox" style={{ cursor: "pointer" }}> Check sheet </label>

                                        <input type="checkbox" id="procedure" name="procedure" value="Procedure" style={{ transform: "scale(1.5)", cursor: "pointer" }} readOnly checked={standardisation.procedure} />
                                        <label htmlFor="procedure" className="custom-checkbox" style={{ cursor: "pointer" }}> Procedure </label>

                                        <input type="checkbox" id="designchange" name="designchange" value="Design change" style={{ transform: "scale(1.5)", cursor: "pointer" }} readOnly checked={standardisation.designchange} />
                                        <label htmlFor="designchange" className="custom-checkbox" style={{ cursor: "pointer" }}> Design change </label>

                                        <input type="checkbox" id="others" name="others" value="Others" style={{ transform: "scale(1.5)", cursor: "pointer" }} readOnly checked={standardisation.others} />
                                        <label htmlFor="others" className="custom-checkbox" style={{ cursor: "pointer" }}> Others </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Document Numbers & Revision Details */}
                        <b style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", textAlign: "center" }}>Document Numbers & Revision Details</b>
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-8">
                                <div className="px-4 py-2 mb-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "30px", }}>
                                    {standardisation.controlplan && <div className="mt-2">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Control Plan :</h6>
                                        <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{documentNumbersRevisionDetails.controlplan}</p>
                                    </div>}
                                    {standardisation.wis && <div className="mt-3">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>WIS :</h6>
                                        <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{documentNumbersRevisionDetails.wis}</p>
                                    </div>}
                                    {standardisation.pfmea && <div className="mt-3">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>PFMEA :</h6>
                                        <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{documentNumbersRevisionDetails.pfmea}</p>
                                    </div>}
                                    {standardisation.pmchecklist && <div className="mt-3">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>PM Check List :</h6>
                                        <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{documentNumbersRevisionDetails.pmchecklist}</p>
                                    </div>}
                                    {standardisation.checksheet && <div className="mt-3">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Check Sheet :</h6>
                                        <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{documentNumbersRevisionDetails.checksheet}</p>
                                    </div>}
                                    {standardisation.procedure && <div className="mt-3">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Procedure :</h6>
                                        <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{documentNumbersRevisionDetails.procedure}</p>
                                    </div>}
                                    {standardisation.designchange && <div className="mt-3">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Design Change :</h6>
                                        <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{documentNumbersRevisionDetails.designchange}</p>
                                    </div>}
                                    {standardisation.others && <div className="mt-3">
                                        <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Others :</h6>
                                        <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{documentNumbersRevisionDetails.others}</p>
                                    </div>}
                                </div>

                            </div>
                            <div className="col-2"></div>

                        </div>

                    </div>
                </div>

                {/* BORDER */}

                <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                    {"+ - ".repeat(1000)}
                </div>

                {/* BENEFITS */}

                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <b style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", textAlign: "center" }}>Benefits (P, Q, C, D, S, M)</b>
                            <div className="pt-3 px-4 mb-2 pb-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px" }}>
                                {improvementCategory.productivity && <div className="mt-2">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Productivity :</h6>
                                    <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{benefits.productivity}</p>
                                </div>}
                                {improvementCategory.quality && <div className="mt-3">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Quality :</h6>
                                    <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{benefits.quality}</p>
                                </div>}
                                {improvementCategory.cost && <div className="mt-3">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Cost :</h6>
                                    <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{benefits.cost}</p>
                                </div>}
                                {improvementCategory.delivery && <div className="mt-3">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Delivery :</h6>
                                    <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{benefits.delivery}</p>
                                </div>}
                                {improvementCategory.safety && <div className="mt-3">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Safety :</h6>
                                    <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{benefits.safety}</p>
                                </div>}
                                {improvementCategory.morale && <div className="mt-3">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Morale :</h6>
                                    <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{benefits.morale}</p>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>

                {/* BORDER */}

                <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                    {"+ - ".repeat(1000)}
                </div>

                {/* SUPPORTING TEAM MEMBERS & DEPARTMENTS */}

                <div className="container">
                    <div className="row">
                        <div className="col-3"></div>
                        <div className="col-6">
                            <b style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", textAlign: "center" }}>Supporting Team Members & Departments</b>
                            <div className="pt-3 px-4 mb-2 pb-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "30px" }}>
                                <p className="p-0 px-1 m-0 text-start border border-success rounded" style={{ fontSize: "13px", backgroundColor: "whitesmoke" }}>{supportingTeamMembers}</p>
                            </div>
                        </div>
                        <div className="col-3"></div>
                    </div>
                </div>

                {/* BORDER */}

                <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                    {"+ - ".repeat(1000)}
                </div>

                {/* BUTTONS */}

                <div className="pb-2" style={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
                    <Button className="fw-bold mx-2" variant="primary" onClick={downloadTableAsImage} >
                        Download
                    </Button>
                    <Button className="fw-bold mx-2" variant="secondary" onClick={handleCloseSeeModal}>
                        Close
                    </Button>
                </div>

            </div>

        </Modal.Body>



        <Modal show={showImageModal}
            onHide={handleCloseImageModal}

            keyboard={false}
            style={{ backgroundColor: "rgba(49, 48, 48, 0.9)" }}>

            <Modal.Body>

                <p className="small fw-bold">Zoom In, Zoom Out, Pinch, Double Tap, Drag and Drop the image to view as per your prespective...!</p>

                <div className="border border-success">
                    <TransformWrapper
                        initialScale={1}
                        minScale={1}
                        maxScale={10}
                        wheel={{ step: 0.2 }}
                        doubleClick={{ disabled: false }}
                        centerOnInit
                        smooth
                    >
                        <TransformComponent
                            wrapperStyle={{
                                width: "100%",
                                height: "100%",
                            }}
                        >
                            <img src={imagePreview} alt="Preview"
                                draggable={false}
                                style={{
                                    width: "600px",
                                    height: "370px",
                                    maxWidth: "100%",
                                    maxHeight: "100%",
                                    objectFit: "contain",
                                }}
                            />
                        </TransformComponent>
                    </TransformWrapper></div>


            </Modal.Body>

            <Modal.Footer>
                <Button className="fw-bold mx-2" variant="primary" onClick={() => handleImageDownload(imagePreview)}>
                    Download
                </Button>
                <Button className="fw-bold mx-2" variant="secondary" onClick={handleCloseImageModal}>
                    Close
                </Button>
            </Modal.Footer>

        </Modal>


        {/* CODE FOR PDF DOWNLOAD */}

        <Modal.Body className="p-0">
            <div ref={tableRef1}>
                <div className="container-fluid px-0 border border-1 border-black" style={{ backgroundImage: `url(${BgImage})`, minHeight: "100vh", backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat", }}>

                    {/* HEADER */}

                    <div className="container-fluid mt-1">
                        <div className="row">
                            <div className="col-2">
                                <div style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "70px", borderRadius: "10px", }}>
                                    <img src={SwipexImage} style={{ width: "100%", height: "auto" }} ></img>
                                </div>
                            </div>
                            <div className="col-8">
                                <div style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "70px", borderRadius: "10px", }}>

                                    <div className="row px-2">
                                        <div className="col-6">
                                            <div className="row" >
                                                <div className="col-5">
                                                    <h6 className="fw-bold" style={{ fontSize: "15px", }}>SWIPEX ID</h6>
                                                </div>
                                                <div className="col-7">
                                                    <h6 className="fw-bold" style={{ fontSize: "17px", color: "green" }}>{swipexID}</h6>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-5">
                                                    <h6 className="fw-bold" style={{ fontSize: "15px", }}>Leader Name / Employee Name</h6>
                                                </div>
                                                <div className="col-7">
                                                    <h6 className="fw-bold" style={{ fontSize: "17px", color: "green" }}>{empName}</h6>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-3">

                                            <div className="row" >
                                                <div className="col-5">
                                                    <h6 className="fw-bold" style={{ fontSize: "15px", }}>Emp ID</h6>
                                                </div>
                                                <div className="col-7">
                                                    <h6 className="fw-bold" style={{ fontSize: "15px", color: "green" }}>{empID}</h6>
                                                </div>
                                            </div>

                                            <div className="row" >
                                                <div className="col-5">
                                                    <h6 className="fw-bold" style={{ fontSize: "15px", }}>Department</h6>
                                                </div>
                                                <div className="col-7">
                                                    <h6 className="fw-bold" style={{ fontSize: "15px", color: "green" }}>{department}</h6>
                                                </div>
                                            </div>

                                            <div className="row" >
                                                <div className="col-5">
                                                    <h6 className="fw-bold" style={{ fontSize: "15px", }}>Location</h6>
                                                </div>
                                                <div className="col-7">
                                                    <h6 className="fw-bold" style={{ fontSize: "15px", color: "green" }}>{location}</h6>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-3">
                                            <div className="row">
                                                <div className="col-5">
                                                    <h6 className="fw-bold" style={{ fontSize: "15px", }}>Start Date</h6>
                                                </div>
                                                <div className="col-7">
                                                    <h6 className="fw-bold" style={{ fontSize: "15px", color: "green" }}>{startDate}</h6>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-5">
                                                    <h6 className="fw-bold" style={{ fontSize: "15px", }}>Implement Date</h6>
                                                </div>
                                                <div className="col-7">
                                                    <h6 className="fw-bold" style={{ fontSize: "15px", color: "green" }}>{implementDate}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="col-2">
                                <div className="p-3" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "70px", borderRadius: "10px", }}>
                                    <img src={SwitchImage2} style={{ width: "100%", height: "auto" }} ></img>
                                </div>
                            </div>

                        </div>

                    </div>

                    {/* BORDER */}

                    <div style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                        {"+ - ".repeat(1000)}
                    </div>

                    {/* PROBLEM DEFINITION, IMPROVEMENT CATEGORY, PROBLEM IMAGES, OBSERVATION ANALYSIS */}

                    <div className="container-fluid">
                        <div className="row">
                            {/* Problem Definition */}
                            <div className="col-5 border-end" style={{ height: "auto" }}>
                                <h6 className="fw-bold" style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", alignItems: "center" }}>Problem Definition (1T 3W 1H)</h6>
                                <div className="px-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "190px", borderRadius: "10px", }}> {/* 290px */}
                                    <div className="row pt-1">
                                        <div className="col-1">
                                            <h6 className="fw-bold" style={{ fontSize: "10px", }}>Title </h6>
                                        </div>
                                        <div className="col-11">
                                            <h6 className="text-primary fw-bold" style={{ fontSize: "10px", textAlign: "justify" }}>{titleProblemDefinition}</h6>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-1">
                                            <h6 className="fw-bold" style={{ fontSize: "10px", }}>What</h6>
                                        </div>
                                        <div className="col-11">
                                            <h6 className="text-primary fw-bold" style={{ fontSize: "10px", textAlign: "justify" }}>{whatProblemDefinition}</h6>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-1">
                                            <h6 className="fw-bold" style={{ fontSize: "10px", }}>Why</h6>
                                        </div>
                                        <div className="col-11">
                                            <h6 className="text-primary fw-bold" style={{ fontSize: "10px", textAlign: "justify" }}>{whyProblemDefinition}</h6>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-1">
                                            <h6 className="fw-bold" style={{ fontSize: "10px", }}>When</h6>
                                        </div>
                                        <div className="col-11">
                                            <h6 className="text-primary fw-bold" style={{ fontSize: "10px", textAlign: "justify" }}>{whenProblemDefinition}</h6>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-1">
                                            <h6 className="fw-bold" style={{ fontSize: "10px", }}>How Many</h6>
                                        </div>
                                        <div className="col-11">
                                            <h6 className="text-primary fw-bold" style={{ fontSize: "10px", textAlign: "justify" }}>{howManyProblemDefinition}</h6>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {/* Improvement Category, Problem Images, Observation Analysis */}
                            <div className="col-7">

                                {/* IC */}
                                <div className="row">
                                    <div className="col-2">
                                        <h6 className="fw-bold m-0" style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", alignItems: "center" }}>Improvement Category</h6>
                                    </div>
                                    <div className="col-10">
                                        <div className="gx-0" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px", fontStyle: "italic" }}>
                                            <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center", fontSize: "10px" }} className="ps-4 gx-0" >
                                                <input type="checkbox" id="productivity" name="productivity" style={{ transform: "scale(1)", cursor: "pointer" }} checked={improvementCategory.productivity} readOnly />
                                                <label htmlFor="productivity" style={{ cursor: "pointer", }}>Productivity</label>

                                                <input type="checkbox" id="quality" name="quality" style={{ transform: "scale(1)", cursor: "pointer" }} checked={improvementCategory.quality} readOnly />
                                                <label htmlFor="quality" style={{ cursor: "pointer" }}>Quality</label>

                                                <input type="checkbox" id="cost" name="cost" style={{ transform: "scale(1)", cursor: "pointer" }} checked={improvementCategory.cost} readOnly />
                                                <label htmlFor="cost" style={{ cursor: "pointer" }}>Cost</label>

                                                <input type="checkbox" id="delivery" name="delivery" style={{ transform: "scale(1)", cursor: "pointer" }} checked={improvementCategory.delivery} readOnly />
                                                <label htmlFor="delivery" style={{ cursor: "pointer" }}>Delivery</label>

                                                <input type="checkbox" id="safety" name="safety" style={{ transform: "scale(1)", cursor: "pointer" }} checked={improvementCategory.safety} readOnly />
                                                <label htmlFor="safety" style={{ cursor: "pointer" }}>Safety</label>

                                                <input type="checkbox" id="morale" name="morale" style={{ transform: "scale(1)", cursor: "pointer" }} checked={improvementCategory.morale} readOnly />
                                                <label htmlFor="morale" style={{ cursor: "pointer" }}>Morale</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Border */}
                                <div style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                                    {"+ - ".repeat(1000)}
                                </div>

                                {/* PI, OA */}
                                <div className="row mx-0">

                                    {/* problem images */}
                                    <div className="col-10 border-end border-secondary">
                                        <h6 className="fw-bold" style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", alignItems: "center" }}>Problem Images</h6>
                                        <div className="row" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px" }}>
                                            <div className="col-9 gx-0">
                                                <div className="d-flex justify-content-center border-primary border-bottom border-end border-1">
                                                    {[0, 1, 2].map((index) => {
                                                        const file = problemImagesPreview[index];
                                                        const preview = file;

                                                        const canUpload =
                                                            index === 0 || !!problemImagesPreview[index - 1];

                                                        return (
                                                            <div className={index == 0 || index == 1 ? "border-primary border-1 border-end" : null}
                                                                key={index}
                                                                style={{
                                                                    width: "400px",
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "center",
                                                                }}
                                                            >
                                                                {preview ? (
                                                                    <>
                                                                        {/* Image */}
                                                                        <img
                                                                            src={preview}
                                                                            alt={`Preview ${index + 1}`}
                                                                            style={{
                                                                                width: "100%",
                                                                                height: "140px",
                                                                                objectFit: "fill", // Fill the border completely
                                                                                border: "1px solid #ddd",
                                                                                cursor: "pointer"
                                                                            }}
                                                                        />

                                                                    </>
                                                                ) : (
                                                                    <div
                                                                        className="d-flex justify-content-center align-items-center"
                                                                        style={{
                                                                            width: "100px",
                                                                            height: "140px", // 180px image + ~28px toolbar space
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={canUpload ? ImageIconDull : ImageIconDull}
                                                                            alt="Upload"
                                                                            style={{
                                                                                width: "50px",
                                                                                height: "50px",
                                                                                cursor: canUpload ? "pointer" : "default",
                                                                                objectFit: "contain",
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                            <div className="col-3 p-0 m-0">
                                                <h6 className="fw-bold px-2" style={{ fontSize: "10px", textAlign: "start", }}> Description :</h6>
                                                <h6 className="text-primary fw-bold px-1" style={{ fontSize: "10px", textAlign: "justify" }}>{imagesDescription.ProblemImageDescription}</h6>
                                            </div>
                                        </div>

                                    </div>

                                    {/* observation analysis */}
                                    <div className="col-2">
                                        <h6 className="fw-bold" style={{ fontSize: "15px", color: "papayawhip", display: "flex", textAlign: "center" }}>Observation & Analysis</h6>
                                        <div style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "125px", borderRadius: "10px", fontStyle: "italic" }}>

                                            <div className="ps-3 flex-column gap-3" >
                                                <div className="d-flex align-items-center pt-1" >
                                                    <input readOnly checked={observationAnalysis === "Man"} type="radio" value="Man" style={{ width: "10px", height: "10px", accentColor: "blue", verticalAlign: "middle" }} />
                                                    <label className="ms-2 my-0 py-0" style={{ cursor: "pointer", fontSize: "10px" }}> Man </label>
                                                </div>
                                                <div className="d-flex align-items-center pt-1">
                                                    <input readOnly checked={observationAnalysis === "Machine"} type="radio" value="Machine" style={{ width: "10px", height: "10px", accentColor: "blue", verticalAlign: "middle" }} />
                                                    <label className="ms-2 my-0 py-0" style={{ cursor: "pointer", fontSize: "10px" }}> Machine </label>
                                                </div>
                                                <div className="d-flex align-items-center pt-1">
                                                    <input readOnly checked={observationAnalysis == "Method"} type="radio" value="Method" style={{ width: "10px", height: "10px", accentColor: "blue", verticalAlign: "middle" }} />
                                                    <label className="ms-2 my-0 py-0" style={{ cursor: "pointer", fontSize: "10px" }}> Method </label>
                                                </div>
                                                <div className="d-flex align-items-center pt-1">
                                                    <input readOnly checked={observationAnalysis === "Material"} type="radio" value="Material" style={{ width: "10px", height: "10px", accentColor: "blue", verticalAlign: "middle" }} />
                                                    <label className="ms-2 my-0 py-0" style={{ cursor: "pointer", fontSize: "10px" }}> Material </label>
                                                </div>
                                            </div>

                                        </div>

                                    </div>


                                </div>


                            </div>
                        </div>

                    </div>

                    {/* BORDER */}

                    <div style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                        {"+ - ".repeat(1000)}
                    </div>

                    {/* ROOT CAUSE */}

                    <div className="container-fluid">
                        <h6 className="fw-bold" style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", alignItems: "center" }}>Root Cause</h6>
                        <div className="px-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px", }}> {/* 290px */}
                            <div className="row pt-1">
                                <div style={{ flex: "0 0 10%" }}>
                                    <h6 className="fw-bold" style={{ fontSize: "10px", }}>Problem Statement :</h6>
                                </div>
                                <div style={{ flex: "0 0 90%" }}>
                                    <h6 className="text-primary fw-bold" style={{ fontSize: "10px", textAlign: "left" }}>{rootCauseProblemStatement}</h6>
                                </div>
                            </div>

                            <div className="row">
                                <div style={{ flex: "0 0 10%" }}>
                                    <h6 className="fw-bold" style={{ fontSize: "10px", }}>Why 1 :</h6>
                                </div>
                                <div style={{ flex: "0 0 90%" }}>
                                    <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{whyRootCause.why1}</h6>
                                </div>
                            </div>

                            {whyrootcausecount > 1 ? <div className="row">
                                <div style={{ flex: "0 0 10%" }}>
                                    <h6 className="fw-bold" style={{ fontSize: "10px", }}>Why 2 :</h6>
                                </div>
                                <div style={{ flex: "0 0 90%" }}>
                                    <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{whyRootCause.why2}</h6>
                                </div>
                            </div> : null}

                            {whyrootcausecount > 2 ? <div className="row">
                                <div style={{ flex: "0 0 10%" }}>
                                    <h6 className="fw-bold" style={{ fontSize: "10px", }}>Why 3 :</h6>
                                </div>
                                <div style={{ flex: "0 0 90%" }}>
                                    <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{whyRootCause.why3}</h6>
                                </div>
                            </div> : null}

                            {whyrootcausecount > 3 ? <div className="row">
                                <div style={{ flex: "0 0 10%" }}>
                                    <h6 className="fw-bold" style={{ fontSize: "10px", }}>Why 4 :</h6>
                                </div>
                                <div style={{ flex: "0 0 90%" }}>
                                    <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{whyRootCause.why4}</h6>
                                </div>
                            </div> : null}

                            {whyrootcausecount > 4 ? <div className="row">
                                <div style={{ flex: "0 0 10%" }}>
                                    <h6 className="fw-bold" style={{ fontSize: "10px", }}>Why 5 :</h6>
                                </div>
                                <div style={{ flex: "0 0 90%" }}>
                                    <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{whyRootCause.why5}</h6>
                                </div>
                            </div> : null}

                        </div>


                    </div>

                    {/* BORDER */}

                    <div style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                        {"+ - ".repeat(1000)}
                    </div>

                    {/* ACTIONS, BEFORE & AFTER IMAGE */}

                    <div className="container-fluid">
                        <div className="row">
                            {/* actions */}
                            <div className="col-8 border-end">
                                <h6 className="fw-bold" style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", alignItems: "center" }}>Actions (3W 1H)</h6>
                                <div className="px-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "210px", borderRadius: "10px", }}>

                                    {/* WHAT */}
                                    <div className={whatactionscount == 1 ? "row gx-0 border-bottom border-secondary" : "row gx-0"}>
                                        <div style={{ flex: "0 0 10%" }}>
                                            <h6 className="fw-bold" style={{ fontSize: "10px", }}>What 1 :</h6>
                                        </div>
                                        <div style={{ flex: "0 0 90%" }}>
                                            <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{whatActions.what1}</h6>
                                        </div>
                                    </div>

                                    {whatactionscount > 1 ? <div className={whatactionscount == 2 ? "row gx-0  border-bottom border-secondary" : "row gx-0 "}>
                                        <div style={{ flex: "0 0 10%" }}>
                                            <h6 className="fw-bold" style={{ fontSize: "10px", }}>What 2 :</h6>
                                        </div>
                                        <div style={{ flex: "0 0 90%" }}>
                                            <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{whatActions.what2}</h6>
                                        </div>
                                    </div> : null}

                                    {whatactionscount > 2 ? <div className={whatactionscount == 3 ? "row gx-0  border-bottom border-secondary" : "row gx-0 "}>
                                        <div style={{ flex: "0 0 10%" }}>
                                            <h6 className="fw-bold" style={{ fontSize: "10px", }}>What 3 :</h6>
                                        </div>
                                        <div style={{ flex: "0 0 90%" }}>
                                            <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{whatActions.what3}</h6>
                                        </div>
                                    </div> : null}

                                    {/* WHEN */}
                                    <div className="row gx-0 py-1 border-bottom border-secondary">
                                        <div className="col-4">
                                            <div className={whatactionscount == 1 ? "row gx-0" : "row gx-0 border-end border-secondary"}>
                                                <div className="col-4 px-2">
                                                    <h6 className="fw-bold" style={{ fontSize: "10px", }}>When 1 :</h6>
                                                </div>
                                                <div className="col-8">
                                                    <h6 className="text-primary fw-bold" style={{ fontSize: "10px", textAlign: "left" }}>{whenActions.when1}</h6>
                                                </div>
                                            </div>
                                        </div>

                                        {whatactionscount > 1 ?
                                            <div className="col-4">
                                                <div className={whatactionscount == 2 ? "row gx-0" : "row gx-0  border-end border-secondary"}>
                                                    <div className="col-4 px-2">
                                                        <h6 className="fw-bold" style={{ fontSize: "10px", }}>When 2 :</h6>
                                                    </div>
                                                    <div className="col-8">
                                                        <h6 className="text-primary fw-bold" style={{ fontSize: "10px", textAlign: "left" }}>{whenActions.when2}</h6>
                                                    </div>
                                                </div>
                                            </div> : null}

                                        {whatactionscount > 2 ?
                                            <div className="col-4">
                                                <div className="row gx-0">
                                                    <div className="col-4 px-2">
                                                        <h6 className="fw-bold" style={{ fontSize: "10px", }}>When 3 :</h6>
                                                    </div>
                                                    <div className="col-8">
                                                        <h6 className="text-primary fw-bold" style={{ fontSize: "10px", textAlign: "left" }}>{whenActions.when3}</h6>
                                                    </div>
                                                </div>
                                            </div> : null}


                                    </div>

                                    {/* WHO */}
                                    <div className={whatactionscount == 1 ? "row gx-0 border-bottom border-secondary" : "row gx-0"}>
                                        <div style={{ flex: "0 0 10%" }}>
                                            <h6 className="fw-bold" style={{ fontSize: "10px", }}>Who 1 :</h6>
                                        </div>
                                        <div style={{ flex: "0 0 90%" }}>
                                            <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{whoActions.who1}</h6>
                                        </div>
                                    </div>

                                    {whatactionscount > 1 ? <div className={whatactionscount == 2 ? "row gx-0 border-bottom border-secondary" : "row gx-0"}>
                                        <div style={{ flex: "0 0 10%" }}>
                                            <h6 className="fw-bold" style={{ fontSize: "10px", }}>Who 2 :</h6>
                                        </div>
                                        <div style={{ flex: "0 0 90%" }}>
                                            <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{whoActions.who2}</h6>
                                        </div>
                                    </div> : null}

                                    {whatactionscount > 2 ? <div className={whatactionscount == 3 ? "row gx-0 border-bottom border-secondary" : "row gx-0"}>
                                        <div style={{ flex: "0 0 10%" }}>
                                            <h6 className="fw-bold" style={{ fontSize: "10px", }}>Who 3 :</h6>
                                        </div>
                                        <div style={{ flex: "0 0 90%" }}>
                                            <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{whoActions.who3}</h6>
                                        </div>
                                    </div> : null}

                                    {/* HOW */}
                                    <div className="row">
                                        <div style={{ flex: "0 0 10%" }}>
                                            <h6 className="fw-bold" style={{ fontSize: "10px", }}>How 1 :</h6>
                                        </div>
                                        <div style={{ flex: "0 0 90%" }}>
                                            <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{howActions.how1}</h6>
                                        </div>
                                    </div>

                                    {whatactionscount > 1 ? <div className="row">
                                        <div style={{ flex: "0 0 10%" }}>
                                            <h6 className="fw-bold" style={{ fontSize: "10px", }}>How 2 :</h6>
                                        </div>
                                        <div style={{ flex: "0 0 90%" }}>
                                            <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{howActions.how2}</h6>
                                        </div>
                                    </div> : null}

                                    {whatactionscount > 2 ? <div className="row">
                                        <div style={{ flex: "0 0 10%" }}>
                                            <h6 className="fw-bold" style={{ fontSize: "10px", }}>How 3 :</h6>
                                        </div>
                                        <div style={{ flex: "0 0 90%" }}>
                                            <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{howActions.how3}</h6>
                                        </div>
                                    </div> : null}

                                </div>
                            </div>
                            {/* before & after image */}
                            <div className="col-4">
                                <div className="row m-0">
                                    <div className="col-6 m-0">
                                        <h6 className="fw-bold" style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", alignItems: "center" }}>Before Image</h6>
                                        <div style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "210px", borderRadius: "10px" }}>
                                            <img src={beforeImagePreview} alt="Before Image" style={{ width: "100%", objectFit: "fill", height: "120px", cursor: "pointer" }} onClick={() => handleOpenImageModal(beforeImagePreview)} />
                                            <div className="mx-2" style={{ lineHeight: 0.8 }}>
                                                <h6 className="fw-bold mb-0" style={{ fontSize: "10px", textAlign: "start", }}> Description :</h6>
                                                <h6 className="text-primary fw-bold mt-0" style={{ fontSize: "9px", textAlign: "justify" }}>{imagesDescription.BeforeImageDescription}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 m-0">
                                        <h6 className="fw-bold" style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", alignItems: "center" }}>After Image</h6>
                                        <div style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "210px", borderRadius: "10px" }}>
                                            <img src={afterImagePreview} alt="After Image" style={{ width: "100%", objectFit: "fill", height: "120px", cursor: "pointer" }} onClick={() => handleOpenImageModal(beforeImagePreview)} />
                                            <div className="mx-2" style={{ lineHeight: 0.8 }}>
                                                <h6 className="fw-bold mb-0" style={{ fontSize: "10px", textAlign: "start", }}> Description :</h6>
                                                <h6 className="text-primary fw-bold mt-0" style={{ fontSize: "9px", textAlign: "justify" }}>{imagesDescription.AfterImageDescription}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* BORDER */}

                    <div style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                        {"+ - ".repeat(1000)}
                    </div>

                    {/* STANDARDISATION, DOCUMENT NUMBERS & REVISION DETAILS, BENEFITS, SUPPORTING TEAM MEMBERS & DEPARTMENTS, APPROVED & VALIDATED BY */}

                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-7 border-end mb-2">
                                {/* Standardisation */}
                                <h6 className="fw-bold" style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", alignItems: "center" }}>Standardisation</h6>
                                <div style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px", fontStyle: "italic", lineHeight:1, padding:0, margin:0 }}>
                                    <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center", padding:0, margin:0 }} className="ps-3" >
                                        <input type="checkbox" value="Control Plan" style={{ transform: "scale(1)", cursor: "pointer", fontSize: "10px" }} readOnly checked={standardisation.controlplan} />
                                        <label className="custom-checkbox" style={{ cursor: "pointer", }}> Control Plan </label>

                                        <input type="checkbox" value="WIS" style={{ transform: "scale(1)", cursor: "pointer" }} readOnly checked={standardisation.wis} />
                                        <label className="custom-checkbox" style={{ cursor: "pointer" }}> WIS </label>

                                        <input type="checkbox" value="PFMEA" style={{ transform: "scale(1)", cursor: "pointer" }} readOnly checked={standardisation.pfmea} />
                                        <label className="custom-checkbox" style={{ cursor: "pointer" }}> PFMEA </label>

                                        <input type="checkbox" value="PM Check list" style={{ transform: "scale(1)", cursor: "pointer" }} readOnly checked={standardisation.pmchecklist} />
                                        <label className="custom-checkbox" style={{ cursor: "pointer" }}> PM Check list </label>

                                        <input type="checkbox" value="Check sheet" style={{ transform: "scale(1)", cursor: "pointer" }} readOnly checked={standardisation.checksheet} />
                                        <label className="custom-checkbox" style={{ cursor: "pointer" }}> Check sheet </label>

                                        <input type="checkbox" value="Procedure" style={{ transform: "scale(1)", cursor: "pointer" }} readOnly checked={standardisation.procedure} />
                                        <label className="custom-checkbox" style={{ cursor: "pointer" }}> Procedure </label>

                                        <input type="checkbox" value="Design change" style={{ transform: "scale(1)", cursor: "pointer" }} readOnly checked={standardisation.designchange} />
                                        <label className="custom-checkbox" style={{ cursor: "pointer" }}> Design change </label>

                                        <input type="checkbox" value="Others" style={{ transform: "scale(1)", cursor: "pointer" }} readOnly checked={standardisation.others} />
                                        <label className="custom-checkbox" style={{ cursor: "pointer" }}> Others </label>
                                    </div>
                                </div>

                                {/* BORDER */}
                                <div style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                                    {"+ - ".repeat(1000)}
                                </div>

                                {/* Document Numbers & Revision Details */}
                                <h6 className="fw-bold" style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", alignItems: "center" }}>Document Numbers & Revision Details</h6>
                                <div className="px-2 py-1" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px", }}> {/* 290px */}
                                    {standardisation.controlplan ? <div style={{ lineHeight: 0.7 }}>
                                        <h6 className="fw-bold mb-0" style={{ fontSize: "10px", }}>Control Plan :</h6>
                                        <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{documentNumbersRevisionDetails.controlplan}</h6>
                                    </div> : null}

                                    {standardisation.wis ? <div style={{ lineHeight: 0.7 }}>
                                        <h6 className="fw-bold mb-0" style={{ fontSize: "10px", }}>WIS :</h6>
                                        <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{documentNumbersRevisionDetails.wis}</h6>
                                    </div> : null}

                                    {standardisation.pfmea ? <div style={{ lineHeight: 0.7 }}>
                                        <h6 className="fw-bold mb-0" style={{ fontSize: "10px", }}>PFMEA :</h6>
                                        <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{documentNumbersRevisionDetails.pfmea}</h6>
                                    </div> : null}

                                    {standardisation.pmchecklist ? <div style={{ lineHeight: 0.7 }}>
                                        <h6 className="fw-bold mb-0" style={{ fontSize: "10px", }}>PM Check List :</h6>
                                        <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{documentNumbersRevisionDetails.pmchecklist}</h6>
                                    </div> : null}

                                    {standardisation.checksheet ? <div style={{ lineHeight: 0.7 }}>
                                        <h6 className="fw-bold mb-0" style={{ fontSize: "10px", }}>Check Sheet :</h6>
                                        <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{documentNumbersRevisionDetails.checksheet}</h6>
                                    </div> : null}

                                    {standardisation.procedure ? <div style={{ lineHeight: 0.7 }}>
                                        <h6 className="fw-bold mb-0" style={{ fontSize: "10px", }}>Procedure :</h6>
                                        <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{documentNumbersRevisionDetails.procedure}</h6>
                                    </div> : null}

                                    {standardisation.designchange ? <div style={{ lineHeight: 0.7 }}>
                                        <h6 className="fw-bold mb-0" style={{ fontSize: "10px", }}>Design Change :</h6>
                                        <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{documentNumbersRevisionDetails.designchange}</h6>
                                    </div> : null}

                                    {standardisation.others ? <div style={{ lineHeight: 0.7 }}>
                                        <h6 className="fw-bold mb-0" style={{ fontSize: "10px", }}>Others :</h6>
                                        <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{documentNumbersRevisionDetails.others}</h6>
                                    </div> : null}

                                </div>



                            </div>
                            <div className="col-5 mb-2" style={{ lineHeight: 0.7 }}>
                                {/* Benefits */}
                                <h6 className="fw-bold" style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", alignItems: "center" }}>Benefits (P, Q, C, D, S, M)</h6>
                                <div className="px-2 py-1" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px", }}> {/* 290px */}
                                    {improvementCategory.productivity ? <div style={{ lineHeight: 0.7 }}>
                                        <h6 className="fw-bold mb-0" style={{ fontSize: "10px", }}>Productivity :</h6>
                                        <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{benefits.productivity}</h6>
                                    </div> : null}

                                    {improvementCategory.quality ? <div style={{ lineHeight: 0.7 }}>
                                        <h6 className="fw-bold mb-0" style={{ fontSize: "10px", }}>Quality :</h6>
                                        <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{benefits.quality}</h6>
                                    </div> : null}

                                    {improvementCategory.cost ? <div style={{ lineHeight: 0.7 }}>
                                        <h6 className="fw-bold mb-0" style={{ fontSize: "10px", }}>Cost :</h6>
                                        <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{benefits.cost}</h6>
                                    </div> : null}

                                    {improvementCategory.delivery ? <div style={{ lineHeight: 0.7 }}>
                                        <h6 className="fw-bold mb-0" style={{ fontSize: "10px", }}>Delivery :</h6>
                                        <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{benefits.delivery}</h6>
                                    </div> : null}

                                    {improvementCategory.safety ? <div style={{ lineHeight: 0.7 }}>
                                        <h6 className="fw-bold mb-0" style={{ fontSize: "10px", }}>Safety :</h6>
                                        <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{benefits.safety}</h6>
                                    </div> : null}

                                    {improvementCategory.morale ? <div style={{ lineHeight: 0.7 }}>
                                        <h6 className="fw-bold mb-0" style={{ fontSize: "10px", }}>Morale :</h6>
                                        <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{benefits.morale}</h6>
                                    </div> : null}
                                </div>

                                {/* BORDER */}
                                <div style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                                    {"+ - ".repeat(1000)}
                                </div>

                                {/* Supporting Team Members & Departments */}
                                <h6 className="fw-bold" style={{ fontSize: "15px", color: "papayawhip", display: "flex", justifyContent: "center", alignItems: "center" }}>Supporting Team Members & Departments</h6>
                                <div className="px-2 py-1" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px", }}> {/* 290px */}
                                    <h6 className="text-primary fw-bold" style={{ fontSize: "10px", }}>{supportingTeamMembers}</h6>
                                </div>


{Accepted ?

<>
                                {/* BORDER */}
                                <div className="mb-1" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                                    {"+ - ".repeat(1000)}
                                </div>

                                <div style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px", }}>
                                    <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                                        <div>
                                            <h6 className="fw-bold mb-0" style={{ fontSize: "15px", }}>Validated By :</h6>
                                            <h6 className="text-success fw-bold" style={{ fontSize: "18px", }}>{validator}</h6>
                                        </div>
                                        <div>
                                            <h6 className="fw-bold mb-0" style={{ fontSize: "15px", }}>Approved By :</h6>
                                            <h6 className="text-success fw-bold" style={{ fontSize: "18px", }}>{approver}</h6>
                                        </div>
                                    </div>
                                </div>

                                 </> : null}

                            </div>
                        </div>
                    </div>




                </div>
            </div>


        </Modal.Body>

    </>)
}

export default See;